module.exports = __webpack_public_path__ + "img/clients-dashboard.7f7331a4.jpg";